import React, { useEffect } from 'react';
import { waLink } from './analytics';
import { Shield, Zap, Headphones } from 'lucide-react';
import './App.css';
import './WebsiteMaintenance.css';
import MaintenancePackages from './components/MaintenancePackages';

function WebsiteMaintenance() {
  useEffect(() => {
    const script = document.createElement('script');
    script.type = 'application/ld+json';
    script.innerHTML = JSON.stringify({
      '@context': 'https://schema.org',
      '@type': 'Service',
      name: 'Website Maintenance',
      description:
        'Layanan perawatan website profesional: keamanan, backup, monitoring, dan dukungan teknis untuk UMKM dan perusahaan.',
      provider: {
        '@type': 'Organization',
        name: 'Cakra Digital Innovation',
        url: 'https://cakra-digital-deploy.vercel.app',
      },
      serviceType: 'Website Maintenance',
      areaServed: 'Indonesia',
    });
    document.head.appendChild(script);
    return () => {
      document.head.removeChild(script);
    };
  }, []);

  return (
    <div className="app wm-page">
      <main>
        <section className="wm-hero">
          <div className="wm-hero__inner">
            <span className="wm-hero__badge">Managed Website Care</span>
            <h1 className="wm-hero__title">Website Maintenance Profesional</h1>
            <p className="wm-hero__subtitle">
              Fokus kembangkan bisnis. Kami yang jaga website Anda tetap aman, optimal,
              dan selalu up-to-date—tanpa repot urus teknis.
            </p>
            <div className="wm-hero__highlights">
              <div className="wm-hero__highlight">
                <Shield size={22} />
                <span>Aman & terawat</span>
              </div>
              <div className="wm-hero__highlight">
                <Zap size={22} />
                <span>Performa optimal</span>
              </div>
              <div className="wm-hero__highlight">
                <Headphones size={22} />
                <span>Support responsif</span>
              </div>
            </div>
            <a
              href={waLink('Halo, saya ingin konsultasi Website Maintenance. Mohon info lebih lanjut.')}
              target="_blank"
              rel="noopener noreferrer"
              className="wm-hero__cta"
            >
              Konsultasi Gratis
            </a>
          </div>
        </section>

        <MaintenancePackages />
      </main>
    </div>
  );
}

export default WebsiteMaintenance;
